import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

/** Timeline entries are ordered by start date descending (newest first). */
function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jan. 2026 – May. 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">AI Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">PBS Wisconsin · Madison, WI</h4>
            <p>
              Built a RAG Slack assistant that ingests Airtable schema and records into ChromaDB embeddings and answers with a local Ollama LLM—enabling natural-language access to internal organizational data.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Sep. 2025 – 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Project Manager</h3>
            <h4 className="vertical-timeline-element-subtitle">LikeLion Wisconsin</h4>
            <p>
              Led <strong>subadger</strong> (Swipe Lease)—a student sublease platform with FastAPI, React Native (Expo), TypeScript, Supabase, and Docker—to simplify rental transfers and improve listing and matching.{' '}
              <a href="https://github.com/Jungwoo-Ryu/subadger" target="_blank" rel="noreferrer">GitHub</a>
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jul. 2025 – Aug. 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">LG Innotek · Seoul, KR</h4>
            <p>
              Researched BLE cybersecurity attack vectors and CVEs for Digital Key systems; developed fuzzing tools for protocol robustness; performed security testing on the Digital Key 2.0 BLE module and documented findings with mitigation recommendations.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jun. 2025 – Jul. 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Fasoo · Seoul, KR</h4>
            <p>
              Developed and operated an integrated project management system for departmental projects and team evaluation workflows.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jun. 2024 – Mar. 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Samsung Life Insurance · Seoul, KR</h4>
            <p>
              Direct Channel Reconstruction: migrated legacy JSP admin pages to Vue 3 and TypeScript; built Spring Boot batch jobs with OracleDB for email campaigns targeting churn-risk customers—improving maintainability and retention operations.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Sep. 2023 – 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">B.S. Computer Science</h3>
            <h4 className="vertical-timeline-element-subtitle">University of Wisconsin–Madison</h4>
            <p>
              Certificates: Microsoft Excel 2020, Word 2020, PowerPoint 2016.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jan. 2023 – May. 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Undergraduate Researcher</h3>
            <h4 className="vertical-timeline-element-subtitle">University of Wisconsin</h4>
            <p>
              Developed a hybrid method to improve imaging quality for Magnetic Induction Tomography (MIT); preprocessed and modularized a large image dataset (Python, OpenCV, NumPy). Selected as a finalist at the Undergraduate Research Symposium.{' '}
              <a href="https://sites.uwm.edu/ug-research-symposium-23/2023/04/24/a-new-computational-method-for-large-scale-inverse-problems-in-magnetic-induction-tomography/" target="_blank" rel="noreferrer">Symposium summary</a>
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Sep. 2022 – May. 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">B.S. Computer Science</h3>
            <h4 className="vertical-timeline-element-subtitle">University of Wisconsin–Milwaukee</h4>
            <p>
              Prior undergraduate studies before transferring to UW–Madison.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
